import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class EventsFetchAPI {
    //Function to create a new event
    static async createEvent(formData, token) {
        const res = await server(`/event`, {
            method: 'POST',
            headers: { 'x-access-token': token },
            data: formData
        });
        return res;
    }

    //Function to asing a date to an event
    static async createEventDate(event_id, formData, token) {
        const res = await server(`/event/${event_id}`, {
            method: 'POST',
            headers: { 'x-access-token': token },
            data: formData
        });
        return res;
    }

    //Function to asing machines to an event
    static async assignMachinestoEvent(data, token) {
        const res = await server(`/machines/event`, {
            method: 'POST',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to asing branchoffices to an event
    static async assignBranchofficestoEvent(data, token) {
        const res = await server(`/branchoffice/by-event`, {
            method: 'POST',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to assign a date to an event 
    static async assigndatetoevent(event_id, data, token) {
        const res = await server(`/event/${event_id}`, {
            method: 'POST',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to get branchoffice by event
    static async getbranchofficeByEvent(event_id, token) {
        const res = await server(`/branchoffice/by-event?event_id=${event_id}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async getEventsByBranchoffice(branchoffice_id, token) {
        const res = await server(`/branchoffice/by-event?branchoffice_id=${branchoffice_id}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }
    
    //Function to get machines by event
    static async getMachinesByEvent(event_date_id, token) {
        const res = await server(`/machines/event?event_date_id=${event_date_id}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to get event by id
    static async getEventById(event_id, token) {
        const res = await server(`/event?event_id=${event_id}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to get all the events by business
    static async getEventsByBusiness(business_id, token) {
        const res = await server(`/event?business_id=${business_id}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res
    }


    //Function to update event 
    static async updateEvent(event_id, data, token) {
        const res = await server(`/event?event_id=${event_id}`, {
            method: 'PUT',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to delete machine from event 
    static async deleteMachineFromEvent(data, token) {
        const res = await server(`/machines/event`, {
            method: 'DELETE',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    //Function to delete branchoffice from event 
    static async deleteBranchofficeFromEvent(data, token) {
        const res = await server(`/branchoffice/by-event`, {
            method: 'DELETE',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    static async updateDateEvent(event_date_id, data, token) {
        const res = await server(`/event_date?event_date_id=${event_date_id}`, {
            method: 'PUT',
            headers: { 'x-access-token': token },
            data: data
        });
        return res;
    }

    static async getRuleByEventId(event_id, token) {
        const res = await server(`/events/rules?event_id=${event_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getRulesEventDetails(event_rule_id, token) {
        const res = await server(`/events/rules/${event_rule_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

     static async getRulesEventProducts(event_rule_id, token) {
        const res = await server(`/events/rules/${event_rule_id}/products`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async createEventRules(data, token) {
        const res = await server(`/events/rules`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

     static async assignProductRuleEvent(event_rule_id, data, token) {
        const res = await server(`/events/rules/${event_rule_id}/products`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

      static async updateEventRules(event_rule_id, data, token) {
        const res = await server(`/events/rules/${event_rule_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

      static async deleteEventRules(event_rule_id, token) {
        const res = await server(`/events/rules/${event_rule_id}`, {
            method: "delete",
            headers: { 'x-access-token': token }
        });
        return res
    }



}